import { BrowserRouter, Routes, Route } from "react-router";
import Authlayout from './layouts/authlayout';
import Adminlayout from './layouts/adminlayout';
import Clientlayout from './layouts/clientlayout';

// auth elements
import Login from './pages/auth/login';
import Register from './pages/auth/register';
import Forgotpassword from './pages/auth/Forgotpassword';



// admin elements 
import Dashboard from './pages/dashboard';
import Users from './pages/users';
import Adduser from './pages/users/adduser';
import Accesscontrol from './pages/accesscontrol/index';
import Createrole from './pages/accesscontrol/createroles';
import Createpermission from './pages/accesscontrol/createpermissions';
import AssignRole from './pages/accesscontrol/assignrole';
import Settings from './pages/settings/settings';
import Language  from "./pages/settings/language";
import Currency  from "./pages/settings/currency";
import Subscription  from "./pages/settings/subscription";
import PermissionSubscription  from "./pages/settings/subspermissions";
import Subsconfig  from "./pages/settings/subsconfig";



// client element
import CLDashboard from './pages/clients/dashboard';
import Departments from './pages/clients/departments';
import Designation from './pages/clients/designation';

//employee
import Employeeindex from './pages/employees/index';
import Basicdetails from './pages/employees/basicdetails';
import Product from './pages/products/product';
import Productadd from './pages/products/add';
import Productedit from './pages/products/edit';
import Productshow from './pages/products/show';

import Shipmenttracking from './pages/shipmenttracking/shipmenttracking';
// import Shipmenttracking from './pages/shipmenttracking/shipmenttracking';

import Ingredient from './pages/ingredient/index';
import Ingredientadd from './pages/ingredient/add';
import IngredientEdit from './pages/ingredient/edit';

import Salesfullfilment from './pages/salesandfullfilment/index';

import Supplier from './pages/supplier/index';
import Addsupplier from './pages/supplier/add';
import Editsupplier from './pages/supplier/edit';
import Suppliershow from './pages/supplier/show';

import Componentsindex from './pages/components/index';
import Componentadd from './pages/components/add';
import ComponentEdit from './pages/components/edit';


import AddBOM from "./pages/bom/addbom";
import EditBOM from "./pages/bom/edit";
import BOM from "./pages/bom/bom";

import Purchaseorder from './pages/purchaseorder/index';
import Createpurchaseorder from './pages/purchaseorder/add';
import Editpurchaseorder from './pages/purchaseorder/edit';
import Showpurchaseorder from  './pages/purchaseorder/show';

import Warehouse from "./pages/warehouses/index";
import WarehouseAdd from "./pages/warehouses/add";
import WarehouseEdit from "./pages/warehouses/edit";

import AddSale from "./pages/salesandfullfilment/add";
import Editsale from "./pages/salesandfullfilment/edit";
import AlertReminders from "./pages/alert-reminders";
import AddAlert from "./pages/alert-reminders/add";
import EditAlert from "./pages/alert-reminders/edit";
import StockTracking from "./pages/stock-tracking";
import OrderTracking from "./pages/order-tracking";
import ProductTracking from "./pages/product-tracking";
import Manufacturing from "./pages/manufacturing";
import ManufacturingAdd from "./pages/manufacturing/add";
import Editmanufacturing from "./pages/manufacturing/edit";

import Manufacturer from './pages/manufacturer';
import ManufacturerAdd from "./pages/manufacturer/add";
import Editmanufacturer from "./pages/manufacturer/edit";

import Stocks from "./pages/stocks/product";
import Addnewstock from "./pages/stocks/add";
import Editstock from "./pages/stocks/edit";
import Quickupdatestock from "./pages/stocks/quickupdatestock";


import Edituser from "./pages/users/Edituser";

import Freight from "./pages/freight_providers";
import FreightAdd from "./pages/freight_providers/add";
import EditFreight from "./pages/freight_providers/edit";

import Shipment from "./pages/shipment";
import AddShipment from "./pages/shipment/add";
import EditShipment from "./pages/shipment/edit";

import CompanyProfile from "./pages/profile";
import Editcompanyprofile from "./pages/profile/edit";


import Stockreports from './pages/reports/stocksreports';
import Stocksproductreports from './pages/reports/stocksproductreports';
import Salesreports from './pages/reports/salesreport';
import Purchaseorderreports from './pages/reports/purchseorderreport';
import Profitlossreports from './pages/reports/profitlossreports';

import Orders from './pages/orders/index';

import Categories from './pages/categories/index';
import AddCategory from './pages/categories/add';
import EditCategory from './pages/categories/edit';


import Stocktransfers from './pages/inventry/stocktransfers';


import ForecastDashboard from './pages/forecasting/forcastdashboard';

export const Adminroutes = () => {
     return (
        <>
         <BrowserRouter>  
            <Routes>
               
              <Route path="/" element={<Adminlayout children={<Dashboard/>} />}/>    
              <Route path="/dashboard" element={<Adminlayout children={<Dashboard/>} />}/>
              <Route path="/product" element={<Adminlayout children={<Product/>} />}/>
              <Route path="/addproduct" element={<Adminlayout children={<Productadd/>} />}/>
              <Route path="/editproduct/:id" element={<Adminlayout children={<Productedit/>} />}/>
              <Route path="/productshow" element={<Adminlayout children={<Productshow/>} />}/>

              <Route path="/shipmenttracking" element={<Adminlayout children={<Shipmenttracking/>} />}/>
              <Route path="/freeissuedingre" element={<Adminlayout children={<Ingredient/>} />}/> 
              <Route path="/addingredient" element={<Adminlayout children={<Ingredientadd/>} />}/>
              <Route path="/editingredient/:id" element={<Adminlayout children={<IngredientEdit/>} />}/>

              <Route path="/suppliers" element={<Adminlayout children={<Supplier/>} />}/> 
              <Route path="/addsupplier" element={<Adminlayout children={<Addsupplier/>} />}/> 
              <Route path="/editsupplier/:id" element={<Adminlayout children={<Editsupplier/>} />}/> 
              <Route path="/supplierdetail" element={<Adminlayout children={<Suppliershow/>} />}/> 
              

              <Route path="/components" element={<Adminlayout children={<Componentsindex/>} />}/> 
              <Route path="/addcomponent" element={<Adminlayout children={<Componentadd/>} />}/> 
              <Route path="/editcomponent/:id" element={<Adminlayout children={<ComponentEdit/>} />}/> 
              
              
              <Route path="/warehouses/index" element={<Adminlayout children={<Warehouse/>} />} /> 
              <Route path="/warehouses/add" element={<Adminlayout children={<WarehouseAdd/>} />} /> 
              <Route path="/warehouses/edit/:id" element={<Adminlayout children={<WarehouseEdit/>} />} /> 
              
              

              <Route path="/salesfullfilment" element={<Adminlayout children={<Salesfullfilment/>} />}/> 
               <Route path="/addsale" element={<Adminlayout children={<AddSale/>} />}/> 
              <Route path="/editsale/:id" element={<Adminlayout children={<Editsale/>} />}/>


              
              
               <Route path="/users" element={<Adminlayout children={<Users/>} />}/> 
               <Route path="/adduser" element={<Adminlayout children={<Adduser/>} />}/> 
               <Route path="/edit-user/:id" element={<Adminlayout children={<Edituser/>} />}/>


              <Route path="/settings" element={<Adminlayout children={<Settings children={<Language/>}/>} />}/> 
              <Route path="/settings/language" element={<Adminlayout children={<Settings children={<Language/>}/>} />}/> 
              <Route path="/settings/currency" element={<Adminlayout children={<Settings children={<Currency/>}/>} />}/> 
              <Route path="/settings/subscription" element={<Adminlayout children={<Settings children={<Subscription/>}/>} />}/> 

              <Route path="/settings/subspermissions" element={<Adminlayout children={<Settings children={<PermissionSubscription/>}/>} />}/> 


              <Route path="/settings/subsconfig" element={<Adminlayout children={<Settings children={<Subsconfig/>}/>} />}></Route>  

              <Route path="/accesscontrol" element={<Adminlayout children={<Accesscontrol children={<Createrole/>}/>} />}/> 
              <Route path="/accesscontrol/createrole" element={<Adminlayout children={<Accesscontrol children={<Createrole/>}/>} />}/> 
              <Route path="/accesscontrol/createpermisson" element={<Adminlayout children={<Accesscontrol children={<Createpermission/>}/>} />}/> 
              <Route path="/accesscontrol/assignrole" element={<Adminlayout children={<Accesscontrol children={<AssignRole/>}/>} />}/> 
              
               
               <Route path="/addbom" element={<Adminlayout children={<AddBOM/>} />}/>
               <Route path="/editbom" element={<Adminlayout children={<EditBOM/>} />}/>
               <Route path="/bom" element={<Adminlayout children={<BOM/>} />}/>


               <Route path="/purchaseorder/:accesstoken?" element={<Adminlayout children={<Purchaseorder/>} />}/>
               <Route path="/createpurchaseorder" element={<Adminlayout children={<Createpurchaseorder/>} />}/>
               <Route path="/editpurchaseorder" element={<Adminlayout children={<Editpurchaseorder/>} />}/>
               <Route path="/showpurchaseorder" element={<Adminlayout children={<Showpurchaseorder/>} />}/>
               
               

               <Route path="/alertreminders" element={<Adminlayout children={<AlertReminders/>} />}/>
               <Route path="/addalerts" element={<Adminlayout children={<AddAlert/>} />}/>
               <Route path="/editalerts" element={<Adminlayout children={<EditAlert/>} />}/>

               <Route path="/stocktracking" element={<Adminlayout children={<StockTracking/>} />}/>
               <Route path="/ordertracking" element={<Adminlayout children={<OrderTracking/>} />}/>
               <Route path="/producttracking" element={<Adminlayout children={<ProductTracking/>} />}/>
               
               <Route path="/manufacturing" element={<Adminlayout children={<Manufacturing/>} />}/>
               <Route path="/addmanufacturing" element={<Adminlayout children={<ManufacturingAdd/>} />}/>
               <Route path="/editmanufacturing/:id" element={<Adminlayout children={<Editmanufacturing/>} />}/>


               <Route path="/manufacturer" element={<Adminlayout children={<Manufacturer/>} />}/>
               <Route path="/addmanufacturer" element={<Adminlayout children={<ManufacturerAdd/>} />}/>
               <Route path="/editmanufacturer/:id" element={<Adminlayout children={<Editmanufacturer/>} />}/>

               <Route path="/stocks" element={<Adminlayout children={<Stocks/>} />}/>
               <Route path="/addnewstock" element={<Adminlayout children={<Addnewstock/>} />}/>
               <Route path="/editstock" element={<Adminlayout children={<Editstock/>} />}/>
               <Route path="/quickupdatestock" element={<Adminlayout children={<Quickupdatestock/>} />}/>
               
               
               <Route path="/freight" element={<Adminlayout children={<Freight/>} />}/>
               <Route path="/freight_add" element={<Adminlayout children={<FreightAdd/>} />}/>
               <Route path="/freight_edit/:id" element={<Adminlayout children={<EditFreight/>} />}/>

               <Route path="/shipment" element={<Adminlayout children={<Shipment/>} />}/>
               <Route path="/addshipment" element={<Adminlayout children={<AddShipment/>} />}/>
               <Route path="/editshipment/:id" element={<Adminlayout children={<EditShipment/>} />}/>
               
               <Route path="/profile" element={<Adminlayout children={<CompanyProfile/>} />}/>
               <Route path="/editprofile" element={<Adminlayout children={<Editcompanyprofile/>} />}/>


               <Route path="/stockreports" element={<Adminlayout children={<Stockreports/>} />}/> 
               <Route path="/stocksproductreports" element={<Adminlayout children={<Stocksproductreports/>} />}/>
               <Route path="/salesreport" element={<Adminlayout children={<Salesreports/>} />}/>  
               <Route path="/purchaseorderreport" element={<Adminlayout children={<Purchaseorderreports/>} />}/>  
               <Route path="/profitlossreport" element={<Adminlayout children={<Profitlossreports/>} />}/>  
               
               <Route path="/orders" element={<Adminlayout children={<Orders/>} />}/>     


               <Route path="/categories" element={<Adminlayout children={<Categories/>} />}/>  
               <Route path="/addcategory" element={<Adminlayout children={<AddCategory/>} />}/> 
               <Route path="/editcategory/:id" element={<Adminlayout children={<EditCategory/>} />}/> 
                

               <Route path="/stocktransfers" element={<Adminlayout children={<Stocktransfers/>} />}/>

               <Route path="/forecast" element={<Adminlayout children={<ForecastDashboard/>} />}/>
                  

            </Routes>
         </BrowserRouter>    
        </>
     );  
}

export const Clientroutes = () => {
   return (
      <>
       <BrowserRouter>  
          <Routes>
            <Route path="/" element={<Clientlayout children={<CLDashboard/>} />}/>    
            <Route path="/dashboard" element={<Clientlayout children={<CLDashboard/>} />}/>
            <Route path="/users" element={<Clientlayout children={<Users/>} />}/> 
            <Route path="/adduser" element={<Clientlayout children={<Adduser/>} />}/> 
            <Route path="/department" element={<Clientlayout children={<Departments/>} />}/>
            <Route path="/designation" element={<Clientlayout children={<Designation/>} />}/>

            {/* // employee  */}
            
            <Route path="/employees/" element={<Clientlayout children={<Employeeindex children={<Basicdetails/>}/>} />}/> 
            <Route path="/employees/basicdetails" element={<Clientlayout children={<Employeeindex children={<Basicdetails/>}/>} />}/> 
            
         </Routes>
       </BrowserRouter>    
      </>
   );  
}

export const Authroutes = () => {
   return (
      <>
       <BrowserRouter>  
          <Routes>
            <Route path="/" element={<Authlayout children={<Login/>} />}/>
            <Route path="/login" element={<Authlayout children={<Login/>} />}/>   
            <Route path="/register" element={<Authlayout children={<Register/>} />}/>
            <Route path="/forgot-password" element={<Authlayout children={<Forgotpassword/>} />}/>
             
          </Routes>
       </BrowserRouter>    
      </>
   );  
}
    

